<template>
  <router-view />
</template>

<script setup lang="ts">
import { useToaster } from '@life_uikit/uikit';
import { setGlobalToastCallback } from '@/shared/api/error-handler';

// Инициализируем глобальный toast callback для error handler
const toast = useToaster();
setGlobalToastCallback((message, options) => {
  toast(message, { toast: { type: options?.type || 'info', duration: options?.duration || 3000 } });
});
</script>

<style src="./app.css"></style>
